import React from 'react';
import './Logo.css';

export const Logo = ({ className, style, alt }) => {
  const src = (process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}` : '') + `/Img/Logo4.png`;

  return (
    <div className="logo-wrapper">
      <img
        src={src}
        alt={alt || 'Logo'}
        className={`logo-img${className ? ' ' + className : ''}`}
        style={style}
      />
    </div>
  );
};
